import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../../const";
import {Toaster, toast} from "react-hot-toast";
import style from "./InterviewModal.module.css";
import DatePicker from "react-datepicker";

function InterviewModal({interval, setFetch, setAfiseazaModala}){
    const [data, setData] = useState(new Date(interval.info.date));
    const [nrLocuri, setNrLocuri] = useState(interval.info.availableSpots + interval.nrLocuriOcupate);
async function handleSubmit() {
        console.log(data, nrLocuri);
        try {
            const res = await axios.patch(
                `${API_URL}/api/interview/${interval.info.id}`,
                {
                    date: data,
                    availableSpots: Number(nrLocuri) - interval.nrLocuriOcupate
                }
            );
            toast.success("Interviul a fost actualizat cu succes!");
        } catch (err) {
            toast.error("Eroare la actualizarea interviului. Există deja un interviu programat la aceeași dată și oră.");
        }
        setFetch(true);
        setAfiseazaModala(false);
    }

    return(
    <div className={style.modalContainer}>
        <div className={style.modal}>
            <button className={style.close} onClick={() => {
                setAfiseazaModala(false);
            }}>x</button>
    <div className={style.create}>
                        <h1>Actualizează interviul</h1>
                        <div className={style.form}>
                            <div className={style.formInput}>
                                <p>Alege data și ora pentru interviu:</p>
                                <div className={style.datepicker}><DatePicker wrapperclassName={style.datepicker} value={data} selected={data} onChange={(d) => setData(d)} showTimeSelect timeIntervals={30} timeFormat="HH:mm" dateFormat="dd.MM.yyyy HH:mm"></DatePicker></div>
                            </div>
                            <div className={style.formInput}>
                                <label htmlFor="nr">Completează numărul de locuri alocate:</label>
                                <input id="nr" name="nr" type="text" value={nrLocuri} onChange={(l) => setNrLocuri(l.target.value)}></input>
                            </div>
                        </div>
                        <button className={style.submitBtn} onClick={() => handleSubmit()}>OK</button>
                    </div></div></div>)

}
export default InterviewModal;